import React, { useContext } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import UnifyButton from '../../../components/Button';
import { N0 } from '../../../components/Colors';
import CardDescription from './Card';
import { ButtonKlaim, ItemDescription, Upper } from './styles';
import UserAuthContext from '../../../components/Context/userContext';

const SectionUpper = () => {
  const userConsumer = useContext(UserAuthContext);
  const history = useHistory();

  return (
    <Upper>
      <p className="header">Kewajiban KUM</p>
      <p className="content">
        Sesuai dengan Peraturan Dekan Fakultas Ekonomi dan Bisnis Universitas
        Indonesia No.1/UN2.F6.D/HKP.02.04.SKD/2019 tentang Kewajiban Mengikuti
        Kuliah Umum dan Seminar Ilmiah Bagi Mahasiswa Jenjang Sarjana, pemenuhan
        kewajiban ini merupakan salah satu kewajiban akademik mahasiswa sebagai
        SYARAT UNTUK DAPAT MELAKSANAKAN UJIAN TUGAS AKHIR. Ketentuan pemenuhan
        kewajiban tersebut bagi mahasiswa tiap angkatan adalah sebagai berikut:
      </p>
      <Row>
        <Col lg={6}>
          <CardDescription
            title="Mahasiswa S1 Reguler dan
  KKI-Single Degree"
          >
            <ItemDescription>
              <p>Angkatan 2019 dst </p>
              <p> 8 KUM</p>
            </ItemDescription>
            <ItemDescription>
              <p>Angkatan 2018 </p>
              <p> 6 KUM</p>
            </ItemDescription>
            <ItemDescription>
              <p>Angkatan 2017 </p>
              <p> 4 KUM</p>
            </ItemDescription>
          </CardDescription>
        </Col>
        <Col lg={6}>
          <CardDescription title="Mahasiswa KKI-Double Degree">
            <ItemDescription>
              <p>Angkatan 2019 dst </p>
              <p> 4 KUM</p>
            </ItemDescription>
            <ItemDescription>
              <p>Angkatan 2018 </p>
              <p> 3 KUM</p>
            </ItemDescription>
            <ItemDescription>
              <p>Angkatan 2017 </p>
              <p> 2 KUM</p>
            </ItemDescription>
          </CardDescription>
        </Col>
        <Col lg={6} />
      </Row>
      <Row>
        <Col className="d-flex justify-content-center mt-4">
          {
            (userConsumer.role === 'admin' || userConsumer.role === 'superadmin') ? (
              <>
                <UnifyButton color="#7F7F7F" textColor={N0} onClick={() => history.push('/Admin/BuatKum')} className="mr-5">
                  <ButtonKlaim>Buat Kuliah Umum</ButtonKlaim>
                </UnifyButton>
                <UnifyButton color="#7F7F7F" textColor={N0} onClick={() => history.push('/Admin/PemeriksaanMahasiswa')}>
                  <ButtonKlaim>Cek Bobot Partisipasi</ButtonKlaim>
                </UnifyButton>
              </>
            ) : (
              <UnifyButton color="#7F7F7F" textColor={N0} onClick={() => history.push('/Mahasiswa/BuatKlaim')}>
                <ButtonKlaim>Klaim KUM Sekarang</ButtonKlaim>
              </UnifyButton>
            )
          }
        </Col>
      </Row>
    </Upper>
  );
};

export default withRouter(SectionUpper);
